export const en = {
    'age-restriction-group-title': 'Age restriction',
    'age-restriction-group-tooltip':
        'According to legislation, the advertising of certain goods (such as mass-media content and baby food) requires an age category (0+, 6+, 12+, 16+, 18+). {link}.',
    'age-restriction-title': 'Age',
    'background-color-title': 'Background color',
    'border-color-title': 'Border color',
    'button-background-color-tooltip':
        'The text must be easy to distinguish from the background color and from the uploaded image. The colors must differ significantly. {link}.',
    'button-group-title': 'Button',
    'button-group-tooltip':
        'A button\'s text must match the action. Example text would be \\"details\\", \\"order\\", \\"purchase\\", etc. {link}.',
    'color-group-title': 'Colors',
    'color-title': 'Text color',
    'common-border-tooltip':
        'Border color must be different from the background (and from the background color and colors in the uploaded file). {link}.',
    'content-title': 'Text',
    'description-group-title': 'Additional text',
    'disclaimer-group-title': 'Warning',
    'disclaimer-group-tooltip':
        'According to legislation, the advertising of certain goods and services (such as medicines, financial services, and shared-equity construction) must contain warnings or additional information. {link}.',
    'disclaimer-title': 'Country',
    'domain-group-title': 'Domain',
    'fade-color-title': 'Color',
    'fade-group-title': 'Tint',
    'fade-group-tooltip':
        'Tint is a translucent single-color layer over an uploaded image. It allows you to create a single-colored background so that it does not distract from the main text or other elements.',
    'headline-group-title': 'Main text',
    'icon-color-title': 'Icon color',
    'image-group-title': 'Image',
    'image-group-tooltip': 'Upload a PNG, JPEG, or non-animated GIF image. Max size 10 MB.',
    'image-title': 'File',
    'legal-group-title': 'Legal Information',
    'legal-group-tooltip':
        'According to legislation, the advertising of certain goods and services (such as medicines, financial services, and shared-equity construction) must contain warnings or additional information. {link}.',
    'link-text': 'Learn more',
    'logo-group-title': 'Logo',
    'logo-title': 'File',
    'special-group-title': 'Special offer'
};
